import { format } from "date-fns";
import { Link } from "gatsby";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import Button from "./Button";

const FeaturedCaseStudy = ({ caseStudy }) => {
	if (!caseStudy?.length > 0) {
		// Return null or placeholder content if caseStudy is not provided
		return null;
	}

	// Option 1: Using optional chaining (supported in modern JS)
	const {
		title,
		slug,
		date,
		caseStudyFields: {
			description,
			featuredImage,
			numberOfMinRead,
			authorName,
			authorImage,
		} = {},
	} = caseStudy?.[0] ?? {};

	const formattedDate = format(new Date(date), "dd MMM yyyy");
	const image = getImage(
		featuredImage?.localFile?.childImageSharp.gatsbyImageData
	);

	return (
		<div>
			{caseStudy && (
				<section className="py-5 py-lg-7">
					<Container>
						<Row className="align-items-center g-4 g-lg-5">
							<Col md={{ span: 6, order: "last" }}>
								{image && (
									<GatsbyImage
										image={image}
										alt={title}
										className="img-fluid "
										style={{ borderRadius: "12px" }}
									/>
								)}
							</Col>
							<Col md={6} className="mb-4 mb-md-0">
								<Link
									to={`/case-studies/${slug}`}
									className="text-decoration-none"
								>
									<h2 className="text-primary display-5">{title}</h2>
								</Link>

								{/* Case Study Description */}
								<p className="pb-3">{description}</p>
								{/* Author and Meta Information */}
								<div className="d-flex align-items-center gap-3 mt-3 pb-1">
									{/* Author Avatar */}
									{authorImage ? (
										<GatsbyImage
											image={
												authorImage.localFile?.childImageSharp?.gatsbyImageData
											}
											alt={authorImage?.altText}
											style={{
												width: "40px",
												height: "40px",
												borderRadius: "50%",
											}}
										/>
									) : (
										<div
											style={{
												width: "40px",
												height: "40px",
												borderRadius: "50%",
												backgroundColor: "#eaeaea",
											}}
										/>
									)}
									<div>
										<p
											className="outfit-bold pb-0 mb-0"
											style={{ color: "#00304B", fontSize: "90%" }}
										>
											{authorName}
										</p>
										<p
											style={{ fontSize: "90%" }}
											className=" mb-0  d-flex align-items-center"
										>
											{formattedDate}{" "}
											<span
												className="mx-2"
												style={{
													display: "inline-block",
													width: "5px",
													height: "5px",
													borderRadius: "50%",
													backgroundColor: "#3BA3DA",
													margin: "0 5px",
												}}
											></span>
											{numberOfMinRead} min read
										</p>
									</div>
								</div>
								<Button
									width="w-100 w-md-auto mt-4"
									colour="#00304B"
									text={"Read Case Study"}
									link={`/case-studies/${slug}`}
									isOutline={true}
								/>
							</Col>
						</Row>
					</Container>
				</section>
			)}
		</div>
	);
};

export default FeaturedCaseStudy;
